import { render } from "./confirmainscricao.vue?vue&type=template&id=63472fb3"
import script from "./confirmainscricao.vue?vue&type=script&lang=js"
export * from "./confirmainscricao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__